import PropTypes from 'prop-types';
import React from 'react';
import { Button, Label, I, Loading } from './ButtonStyles';
import { Icon } from 'antd';

const ButtonComponent = ({
  onClick,
  width,
  loading,
  type,
  disabled,
  label,
  icon,
  category
}) => {
  return (
    <Button
      width={width}
      type={type}
      onClick={onClick}
      category={category}
      disabled={disabled}
    >
      {loading && (
        <Loading category={category}>
          <Icon type="loading" theme="outlined" />
        </Loading>
      )}
      <Label>{label}</Label>
      <I>{icon}</I>
    </Button>
  );
};

ButtonComponent.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func
};

ButtonComponent.defaultProps = {
  type: 'submit',
  icon: <Icon type="arrow-right" theme="outlined" />,
  label: 'Continue',
  category: 'primary',
  width: '100%'
};

export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonComponent.js